import React, { useEffect, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Button } from 'foundations-library/components'
import { Feature } from 'widgets'
import { HowToArticle } from './../../../../../utils/objects'
import { useWidgetContext, FeatureType } from 'providers'
/**
 *
 */
export const items = {
    articles: [
        {
            title: 'Activating your cellular service on iPhone'
        },
        {
            title: 'Activating your cellular service on Android'
        },
        {
            title: 'Terminating your cellular service'
        },
        {
            title: 'Configuring your phone number'
        },
        {
            title: 'Troubleshooting your cellular service'
        },
        {
            title: 'Troubleshooting your cellular service'
        },
        {
            title: 'Making a phone call on iPhone'
        },
        {
            title: 'Making a phone call on Android'
        },
        {
            title: 'Checking if your device is locked on iPhone'
        }
    ]
}

const useStyles = makeStyles(theme => ({
    articlesRoot: {
        rowGap: '.5rem'
    },
    title: { margin: 'auto', padding: '1.5rem 0 3rem' },
    articlesContainer: {},
    viewMoreBtn: { margin: '2rem auto 0' }
}))

/**
 *
 */
export const Articles = ({ articles }: { articles: HowToArticle[] }) => {
    const classes = useStyles()
    return (
        <Grid container className={classes.articlesContainer} spacing={3}>
            {
                articles.map(article => <Feature key={article.title} title={article.title} />)
            }
        </Grid>
    )
}

/**
 *
 */
const Index = () => {
    const classes = useStyles()
    const { findSectionBySlug, remoteValue } = useWidgetContext()
    const [articles, setArticles] = useState<FeatureType[]>([])
    useEffect(() => {
        const section = findSectionBySlug('esim')
        if (section) {
            setArticles(section.articles || [])
        }
    }, [remoteValue])

    return (
        <Grid container xs={12} className={classes.articlesRoot}>
            <Typography variant='h2' className={classes.title}>How-to-articles</Typography>
            <Articles articles={articles} />
            <Button variant='outlined' size='large' color='secondary' className={classes.viewMoreBtn}>View more</Button>
        </Grid>
    )
}

Index.displayName = 'Articles'

export default Index
